import { CenteredBlocks } from "@features/content/CenteredBlocks"
import { useBackground } from "@hooks/useAppState"
import { defineView } from "eddev/views"

export default defineView("archive-case-study", (props) => {
  useBackground({
    scene: "idle",
    darken: 0.8,
  })

  return (
    <div>
      <CenteredBlocks blocks={props.page?.contentBlocks} />
    </div>
  )
})
